import React, { useEffect, useState } from "react";
import { NavLink, useNavigate, Link } from "react-router-dom";
// import Logo from "../../assets/images/Logo.jpg";
import Logo from "../../assets/images/Logo1.png";
import { FaBars, FaTimes } from "react-icons/fa";
import "../Header/Header.css";
import { getUserById } from "../api/api";

const Header = () => {
  const navigate = useNavigate();
  const [userData, setUserdata] = useState(null);
  const [menuOpen, setMenuOpen] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const [influencerData, setInfluencerData] = useState(null);
  const storedInfluencer = localStorage.getItem("influencerData");

  const getUser = async () => {
    const storedUser = localStorage.getItem("currentUser");
    if (!storedUser) return navigate("/Login");

    let parsedUser;
    try {
      parsedUser = JSON.parse(storedUser);
    } catch (error) {
      console.error("Error parsing user:", error);
      return navigate("/Login");
    }

    const _id = parsedUser?.id || parsedUser?._id;
    if (!_id) return navigate("/Login");

    try {
      const res = await getUserById({ user_id: _id });
      console.log("getUserById_header", JSON.stringify(res));
      if (!res?.success || !res?.data) {
        return navigate("/Login");
      }

      const user = res.data;
      localStorage.setItem("currentUser", JSON.stringify(user));
      const nav = (path) => navigate(path);

      if (user.type === "counsellor") {
        switch (user.profile_completion_status) {
          case "emailvarification":
            return nav("/CounsellorEmailVerification");
          case "uploadDocument":
          case "CounsellorDocumentation":
            return nav("/CounsellorDocumentation");
          case "CounsellorImageUpload":
            return nav("/CounsellorImageUpload");
          case "CounsellorFinalSubmission":
            return nav("/CounsellorFinalSubmission");
          case "Tab":
            if (user.approve_reject === "approved") {
              return nav("/CounsellorSidebar");
            } else if (user.approve_reject === "rejected") {
              return nav("/CounsellorDocumentation");
            } else {
              return nav("/CounsellorFinalSubmission");
            }
          default:
            return nav("/Login");
        }
      } else {
        if (user.approve_reject === "rejected") {
          return nav("/DocumentUpload");
        }

        switch (user.profile_completion_status) {
          case "gender":
            return nav("/Gender");
          case "paymentscreen":
            return nav("/PaymentScreen");
          case "UploadImage":
            return nav("/UploadImage");
          case "RegistrationVarification":
            return nav("/RegistrationVarification");
          case "Lovelanguage":
            return nav("/Lovelanguage");
          case "UpdateMatchPreferences":
            return nav("/UpdateMatchPreferences");
          case "userAnswersValue":
            return nav("/ValuesAssessment");
          case "userAnswersIQ":
            return nav("/IQAssessment");
          case "Lovelanguage":
            return nav("/Lovelanguage");
          case "ConnectionPayment":
            return nav("/ConnectionPayment");
          case "FinalSubmissionPage":
            return nav("/FinalSubmissionPage");
          case "uploadDocument":
            return nav("/DocumentUpload");
          case "cultureReligion":
            return nav("/CultureReligion");
          case "interest":
            return nav("/Interest");
          case "UpdateProfileDetails":
            return nav("/UpdateProfileDetails");
          case "UpdateMatchPreferences":
            return nav("/UpdateMatchPreferences");
          case "userAnswersTemperament":
            return nav("/TemperamentQuestion");
          //   case "Tab":
          //     if (user.approve_reject === "approved") {
          //       if (user.approve_reject_new_image === "pending") {
          //         return nav("/DocumentVerification");
          //       } else if (user.activeSubscriptionStatus === "0") {
          //         return nav("/SubscriptionBlurPage");
          //       } else {
          //         return nav("/Sidebar");
          //       }
          //     } else {
          //       return nav("/FinalSubmissionPage");
          //     }
          //   default:
          //     return nav("/Login");
          // }
          case "Tab":
            if (user.approve_reject === "approved") {
              if (user.approve_reject_new_image === "pending") {
                return nav("/DocumentVerification");
              } else if (user?.data?.subscription?.object === "subscription") {
                return nav("/Sidebar");
              } else {
                if (user?.data?.subscription?.object !== "subscription") {
                  // console.log('12546_yeee');
                  if (user?.data?.subscription_status === "past_due") {
                    navigate("/SubscriptionBlurPage", {
                      state: { past_due: "past_due" },
                    });
                  } else {
                    navigate("/SubscriptionBlurPage", {
                      state: { past_due: "" },
                    });
                  }
                }
              }

              // else if (user.activeSubscriptionStatus === "0") {
              //   return nav("/SubscriptionBlurPage");
              // } else {
              //   return nav("/Sidebar");
              // }
            } else {
              return nav("/FinalSubmissionPage");
            }
          default:
            return nav("/Login");
        }
      }
    } catch (err) {
      console.error("Error in getUserById:", err);
      return navigate("/Login");
    }
  };

  const InfluencerLogin = async () => {
    navigate("/AffiliateAccess");
  };

  const toggleMenu = () => {
    setMenuOpen((prev) => !prev);
  };

  return (
    <div className="HeaderContainer">
      <div className="containerall">
        <div className="HeaderBottomRow">
          <div className="logo">
            <a href="/">
              <img src={Logo} alt="Logo" />
            </a>
          </div>
          <div className="hamburger-icon" onClick={toggleMenu}>
            {menuOpen ? <FaTimes size={24} /> : <FaBars size={24} />}
          </div>
          <nav className={`nav-links ${menuOpen ? "open" : ""}`}>
            {/* <NavLink
              to="/"
              onClick={() => setMenuOpen(false)}
              className={({ isActive }) => (isActive ? "active" : "")}
            >
              Home
            </NavLink> */}
            <a
              href="https://connecttovow.com"
              onClick={() => setMenuOpen(false)}
              className={({ isActive }) => (isActive ? "active" : "")}
              rel="noopener noreferrer"
            >
              Home
            </a>
            <span
              onClick={() => {
                getUser();
                setMenuOpen(false);
              }}
              className="button-navs-link"
              style={{ cursor: "pointer" }}
            >
              {userData?.data?.name
                ? `Hi ${userData?.data?.name.split(" ")[0]}`
                : "Find A Match"}
            </span>
            {/* <NavLink
              to="/services"
              onClick={() => setMenuOpen(false)}
              className={({ isActive }) => (isActive ? "active" : "")}
            >
              Membership
            </NavLink> */}
            <a
              href="https://connecttovow.com/ourpricing"
              onClick={() => setMenuOpen(false)}
              className={({ isActive }) => (isActive ? "active" : "")}
              rel="noopener noreferrer"
            >
              Membership
            </a>
            {/* <NavLink
              to="/about"
              onClick={() => setMenuOpen(false)}
              className={({ isActive }) => (isActive ? "active" : "")}
            >
              About Us
            </NavLink> */}
            <a
              href="https://connecttovow.com/aboutus"
              onClick={() => setMenuOpen(false)}
              className={({ isActive }) => (isActive ? "active" : "")}
              rel="noopener noreferrer"
            >
              About Us
            </a>
          </nav>
        </div>
      </div>
    </div>
  );
};

export default Header;
